import { WatchList } from './watch-list';

export class WatchLists {
  data: WatchList[] = [];

  private constructor() {}

  static fromData = (data: any) => {
    if (!data) {
      // throw new Error('Data is undefined');
      return new WatchLists();
    }
    const model = new WatchLists();
    model.data = (data?.watchLists || []).map((w: any) => WatchList.fromData(w));
    return model;
  };

  static fromSelf = (self: WatchLists) => {
    if (!self) {
      throw new Error('Self is undefined');
    }
    const clone = new WatchLists();
    clone.data = self.data.map((wl) => WatchList.fromSelf(wl));
    return clone;
  };

  static fromEmpty = () => {
    return new WatchLists();
  };

  public sort = () => {
    const sortedWatchLists = this.sortByWatchListName();
    return sortedWatchLists;
  };

  /**
   * Sorts the watch list data array in-place by the `name` property of each item,
   * using a locale-aware string comparison with English locale and variant sensitivity.
   * 
   * @returns The current instance for method chaining.
   */
  private sortByWatchListName = () => {
    this.data.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'variant' }));
    return this;
  };

  // Sort By Global or User(None)
  private sortByWatchListType = () => {
    this.data.sort((watchList1, watchList2) => (watchList1.type > watchList2.type ? 1 : -1));
    return this;
  };

  // public static fromSelf = (lists: WatchLists): WatchLists => {
  //   if (!lists) {
  //     throw Error('Lists is null or undefined');
  //   }
  //   //const model = new WatchLists(lists);
  //   return model;
  // };
}
